import { Record } from 'immutable';
import memoize from 'transmute/memoize';
export const validName = memoize(name => {
  return name !== null && name !== '';
});
export default class UserProfile extends Record({
  firstName: undefined,
  lastName: undefined,
  hasEditEmail: undefined,
  emailAddress: undefined,
  emailHash: undefined,
  pendingEmailAddress: undefined,
  loginEmails: undefined,
  canSelfDelete: undefined,
  scim: null
}) {}